import React from 'react';

const LinkedinLogoSvg = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 71.903 72"
    className="linkedin-logo"
    style={{ fill: props.fill }}
  >
    <path
      className="a"
      d="M67.5,0H4.5A4.481,4.481,0,0,0,0,4.5V67.4A4.5,4.5,0,0,0,4.5,72H67.4a4.481,4.481,0,0,0,4.5-4.5V4.5A4.337,4.337,0,0,0,67.5,0ZM24.7,56H16.3V29.1h8.4ZM20.5,25.4a4.8,4.8,0,1,1,4.8-4.8A4.679,4.679,0,0,1,20.5,25.4ZM56,56H47.6V42.9c0-3.1-.1-7.1-4.3-7.1-4.3,0-5,3.4-5,6.9V56H30V29.1h8v3.7h.1A8.709,8.709,0,0,1,46,28.5c8.5,0,10,5.6,10,12.8Z"
    />
  </svg>
);

export default LinkedinLogoSvg;
